import { useEffect } from "react";
import { getConfig } from "../../../config/config";
import { RAG_RECOMMENDATION_WIDGET_MESSAGE_TYPE, RRWidgetOutboundMessage } from "../constants/ragRecommendationWidget";
import { noop } from "lodash";

type TProps = {
  /** Здесь можно подписаться на события iframe для их последующей обработки на сайте **/
  iframeClick: () => void;
};

const config = getConfig();

/** Хук, предназначен для отслеживания событий iframe виджета чат-бота **/
export const useRagRecommendationWidgetIframe = ({ iframeClick }: TProps) => {
  useEffect(() => {
    if (!config.features.ragRecommendationWidget.enabled) return;

    const onMessage = (event: MessageEvent) => {
      /** Проверяем, что клик происходит из необходимого iframe **/
      if (event.origin !== config.ragRecommendationWidget.url) return;

      const eventData: (RRWidgetOutboundMessage & Record<string, unknown>) | undefined = event.data;

      if (!eventData) return;

      switch (eventData.type) {
        /** Обрабатываем то или иное событие как нам необходимо **/
        case RAG_RECOMMENDATION_WIDGET_MESSAGE_TYPE['iframeClick']: {
          iframeClick();
          break;
        }
        default: {
          noop();
        }
      }
    }

    window.addEventListener('message', onMessage);

    return () => {
      window.removeEventListener('message', onMessage)
    }
  }, []);
}
